<template>
<v-app>

  <!-- <v-container>
  <v-row class="mt-5 pt-5 mb-5">
  <v-col md3="md3"></v-col>
  <v-col md6="md6" xs12="xs12" class="mt-2">

  <div class="display-2">
    <v-icon class="display-3 primary--text pr-2 pb-2" style="vertical-align: middle">people</v-icon>
    {{title}}
  </div>
</v-col>
</v-row>
</v-container> -->


<!-- <v-card class="ma-4"> -->

<!-- </v-card> -->

<v-card class="">
  <v-card-title class=" pt-5">
    <div class="">
      <v-icon class="primary--text pr-2 pb-1" style="vertical-align: middle">people</v-icon>
      {{title}}
    </div>
    <v-spacer></v-spacer>
    <v-text-field v-if="search"
      append-icon="search"
      label="Search"
      single-line
      hide-details
      v-model="search_text"
    ></v-text-field>
  </v-card-title>

  <v-data-table
      v-bind:headers="headers"
      v-model="items"
      v-bind:search="search_text"
      :select-all=edit
      hide-actions
    >

    <template slot="items" scope="props">
      <td v-if="edit">
        <v-checkbox
          hide-details
          primary
          v-model="props.item.value"
        ></v-checkbox>
      </td>
      <td>{{ props.item.name }}</td>
      <td class="text-xs-right">{{ props.item.email }}</td>
      <td class="text-xs-right">{{ props.item.mobile }}</td>
      <td class="text-xs-right">{{ props.item.city }}</td>
      <td class="text-xs-right">{{ props.item.type }}</td>
      <td class="text-xs-right">{{ props.item.fee }}</td>
      <td class="text-xs-right">{{ props.item.accepted }}</td>
      <td class="text-xs-right">{{ props.item.requested }}</td>
      <td class="text-xs-right">{{ props.item.status }}</td>
    </template>
  </v-data-table>
</v-card>



<!-- <v-card class="primary mt-0" height="200px" /> -->

</v-app>
</template>

<script>
// Firebase
import firebase from '../modules/firebase'
// Locale
// import locale from '../modules/locale'
// Store
import store from '../modules/store'

export default {
  data () {
    return {
      store,
      members: {},
      edit: false,
      search: true,
      search_text: '',
      title: 'Libro soci',
      headers: [
        {text: 'Nome e Cognome', value: 'name', left: true},
        {text: 'Email', value: 'email'},
        {text: 'Cellulare', value: 'mobile'},
        {text: 'Città', value: 'city'},
        {text: 'Socio', value: 'type'},
        {text: 'Quota', value: 'fee'},
        {text: 'Accettato', value: 'accepted'},
        {text: 'Richiesta', value: 'requested'},
        {text: 'Stato', value: 'status'}
      ],
      items: []
    }
  },
  watch: {
    // 'items': function () {
    //   console.log(this.items)
    // }
  },
  beforeMount: function () {
    var items = []
    firebase.database().ref('members/users/').once('value')
    .then((snapshot) => {
      var data = snapshot.val()
      for (var kk in data) {
        var member = {value: false}
        for (var pp in data[kk]) {
          member[pp] = data[kk][pp]
        }
        items.push(member)
      }
      this.items = items
    })
  }
}
</script>

<style scoped>
blockquote{
  border-left: 0px;
  padding-left: 0rem;
}
/*table tbody td, table thead th {
  padding: 0 0px;
}*/
/*.re {
  font-size: 1.4rem;
}
@media (min-width: 600px) {
  .re {
    font-size: 3rem;
  }
}*/

</style>



// WEBPACK FOOTER //
// Administration.vue?8874b55c